import { render } from "./ClickToCopy.vue?vue&type=template&id=56473d20"
import script from "./ClickToCopy.vue?vue&type=script&lang=ts"
export * from "./ClickToCopy.vue?vue&type=script&lang=ts"
script.render = render

export default script